import React, { useState, useEffect } from "react";
import PageDescription from "../../DataAnalyst/sections/PageDescription";
import FileUpload from "./sections/FileUpload";
import MastersLibrary from "./sections/MastersLibrary";
import PreviewSection from "./sections/PreviewSection";
import ProcessingLoader from "./sections/ProcessingLoader";
import Settings from "./sections/Settings";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ChatInput from "../../AmplitudeAI/Chat/ChatInput";
import AppTour from "../../../../components/AppTour/AppTour";
import { useLocation } from "react-router-dom";
import { STATUS, ACTIONS, EVENTS } from "react-joyride";
import { masteringEngineerTourSteps } from "../../../../components/AppTour/ModuleTourSteps";

export default function AudioEngineerDemo() {
    const location = useLocation();
    const [runTour, setRunTour] = useState(false);
    const [target, setTarget] = useState(null);
    const [currentStep, setCurrentStep] = useState(0);
    const [showUpload, setShowUpload] = useState(true);
    const [showSettings, setShowSettings] = useState(false);
    const [showProcessing, setShowProcessing] = useState(false);
    const [showPreview, setShowPreview] = useState(false);
    const [newFile, setNewFile] = useState(true);
    const [genre, setGenre] = React.useState("ROCK_INDIE");
    const [loudness, setLoudness] = React.useState("MEDIUM");
    const [sampleRate, setSampleRate] = React.useState("48000");

    useEffect(() => {
        if (location.hash === "#start-tour") {
            setRunTour(true);
        }
    }, [location.hash]);

    // Handle tour step changes
    const handleTourStepChange = (data) => {
        console.log("Tour step changed:", data.step?.target);
        setTarget(data.step?.target);
    };

    const handleFileSelect = () => {
        setNewFile(false);
        setShowUpload(false);
        setShowSettings(true);
        // Simulate progression
        setTimeout(() => {
            setShowSettings(false);
            setShowProcessing(true);
        }, 2000);
        setTimeout(() => {
            setShowProcessing(false);
            setShowPreview(true);
        }, 5000);
    };

    const handleNew = () => {
        setNewFile(true);
        setShowUpload(true);
        setShowSettings(false);
        setShowProcessing(false);
        setShowPreview(false);
    };

    const handleSend = () => {
        alert("Demo: This would send a message to Amplitude AI in the live version");
    };

    return (
        <div className="DataAnalyst-page py-5">
            <ToastContainer />
            <AppTour
                tourSteps={masteringEngineerTourSteps}
                runTour={runTour}
                setRunTour={setRunTour}
                callback={handleTourStepChange}
            // setTarget={setTarget}
            />
            <div className="container max-w-full">
                <PageDescription
                    title="Your Mastering Engineer - Demo Mode"
                    description="Create studio-quality masters in minutes — powered by intelligent, genre-aware AI. (Demo with sample data)"
                />

                <div className="mt-4 p-4 md:p-8 bg-theme_clr1 rounded-2xl">
                    {/* Upload Section */}
                    <div data-tour="upload-section" className="transition-all duration-300">
                        <FileUpload onFileSelect={handleFileSelect} />
                    </div>

                    {/* Settings Section */}
                    <div data-tour="settings-section" className="max-w-[500px] bg-white rounded-lg p-6 mb-4 mx-auto transition-all duration-300 mt-8">
                        <Settings
                            genre={genre}
                            setGenre={setGenre}
                            loudness={loudness}
                            setLoudness={setLoudness}
                            sampleRate={sampleRate}
                            setSampleRate={setSampleRate}
                        />
                        <button
                            onClick={() => {
                                setShowSettings(false);
                                setShowProcessing(true);
                            }}
                            className="mt-4 w-full max-w-md bg-theme_clr4 text-white py-3 rounded-xl hover:opacity-90 transition-opacity font-medium block mx-auto mt-8"
                        >
                            Save Settings & Start Processing
                        </button>
                    </div>

                    {/* Processing Section */}
                    {/* {showProcessing && ( */}
                    <div data-tour="processing-section" className="transition-all duration-300 mt-8">
                        <ProcessingLoader isMaster={false} isDemo />
                    </div>
                    {/* )} */}

                    {/* Preview Section */}
                    {/* {showPreview && ( */}
                    <div data-tour="preview-section" className="transition-all duration-300 mt-8">
                        <PreviewSection demoMode taskIds={["demo-task-1", "demo-task-2"]} />
                    </div>

                    <div data-tour="master-section" className="transition-all duration-300 mt-8">
                        <PreviewSection demoModeMaster taskIds={["demo-task-1", "demo-task-2"]} />
                    </div>
                    {/* )} */}
                </div>

                {/* Chat and Library - Always visible after initial steps */}
                <div className="mt-4" data-tour="amplitude-ai-chat">
                    <ChatInput
                        title="Plan your next move with your mastered tracks."
                        inputPlaceholder="Let Amplitude AI design the perfect release strategy."
                        onSend={handleSend}
                        isDisabled={false}
                    />
                </div>

                <div className="mt-4" data-tour="masters-library">
                    <MastersLibrary addNew={handleNew} handleSettings={() => { }} />
                </div>

                {/* Demo Info Box */}
                <div className="mt-6 bg-blue-50 border-l-4 border-blue-500 rounded p-4">
                    <p className="text-blue-900 font-semibold mb-2">ℹ️ Demo Mode</p>
                    <p className="text-blue-800 text-sm">
                        This is a demonstration page showing the Audio Engineer mastering interface. All data is simulated for demo purposes.
                    </p>
                </div>
            </div>
        </div>
    );
}
